import * as React from 'react'

function SvgIconBrightnessMid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="brightness-mid"
        aria-labelledby="t-brightness-mid d-brightness-mid"
      >
        <title id="t-brightness-mid">{'Brightness mid'}</title>
        <desc id="d-brightness-mid">{'A circle radiating 8 short lines'}</desc>
        <path d="M16 12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 10c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM8.9 10.3L7.5 8.9c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.4 1.4c.4.4.4 1 0 1.4-.3.4-1 .4-1.4 0zM7 17H5c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1zm.5 7.5c-.4-.4-.4-1 0-1.4l1.4-1.4c.4-.4 1-.4 1.4 0 .4.399.4 1 0 1.399l-1.4 1.396c-.4.405-1 .405-1.4.005zM16 28c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1s1 .4 1 1v2c0 .6-.4 1-1 1zm7.1-3.5l-1.4-1.4c-.4-.396-.4-1 0-1.396a.967.967 0 011.399 0l1.396 1.396c.396.4.396 1 0 1.4s-.995.4-1.395 0zM27 17h-2c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1zm-5.3-6.7c-.4-.4-.4-1 0-1.4l1.4-1.4c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-1.4 1.4c-.4.4-1.1.4-1.4 0zM16 8c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1s1 .4 1 1v2c0 .6-.4 1-1 1z" />
      </g>
    </svg>
  )
}

export default SvgIconBrightnessMid
